import { ThemeEvents } from '@theme/events';

class SpecificationLink extends HTMLElement {
  /** @type {HTMLAnchorElement | null} */
  anchor = null;

  connectedCallback() {
    this.anchor = this.querySelector('[data-specification-link-anchor]');
    this.anchor?.addEventListener('click', this.handleClick);
    document.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  disconnectedCallback() {
    this.anchor?.removeEventListener('click', this.handleClick);
    document.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  /** @param {MouseEvent} e */
  handleClick = (e) => {
    e.preventDefault();
    const target = document.querySelector(this.anchor?.getAttribute('href') ?? '');
    if (!target) return;

    const isMobile = window.innerWidth < 750;
    if (isMobile) {
      const top = target.getBoundingClientRect().top + window.scrollY - 56;
      window.scrollTo({ top, behavior: 'smooth' });
    } else {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  handleVariantUpdate = () => {
    requestAnimationFrame(() => {
      const specsSection = document.querySelector('#product-specifications');
      const hasSpecs = specsSection && !specsSection.classList.contains('product-specifications-section--empty');
      this.classList.toggle('specification-link--hidden', !hasSpecs);
    });
  };
}

if (!customElements.get('specification-link')) {
  customElements.define('specification-link', SpecificationLink);
}
